export const TENANT_PANASONIC_URI = "panasonic"
export const TENANT_FLIPKART_URI = "smarthomeplus"
export const TENANT_AMAZON_URI = "appliancehub"
export const ISD_CODES = [
  { code: "+91", label: "India (+91)" },
  { code: "+1", label: "USA (+1)" },
  { code: "+44", label: "UK (+44)" },
];